// import { createSlice, PayloadAction } from "@reduxjs/toolkit";
// import { Car } from "../types/car";

// interface CartState {
//   items: Car[];
// }

// const initialState: CartState = {
//   items: [],
// };

// const cartSlice = createSlice({
//   name: "cart",
//   initialState,
//   reducers: {
//     addToCart(state, action: PayloadAction<Car>) {
//       const exists = state.items.find(
//         (item) => item.id === action.payload.id
//       );
//       if (!exists) {
//         state.items.push(action.payload);
//       }
//     },

//     removeFromCart(state, action: PayloadAction<string>) {
//       state.items = state.items.filter(
//         (item) => item.id !== action.payload
//       );
//     },

//     clearCart(state) {
//       state.items = [];
//     },
//   },
// });

// export const { addToCart, removeFromCart, clearCart } =
//   cartSlice.actions;

// export default cartSlice.reducer;

import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Car } from "../types/car";

export interface CartItem {
    car: Car;
    quantity: number;
}

export interface CartState {
    items: CartItem[];
}

const loadCart = (): CartItem[] => {
    try {
        const data = localStorage.getItem("cart");
        return data ? JSON.parse(data) : [];
    } catch {
        return [];
    }
};

const saveCart = (items: CartItem[]) => {
    localStorage.setItem("cart", JSON.stringify(items));
};

// const initialState: CartState = {
//   items: loadCart(),
// };

const initialState: CartState = {
    items: [],
};

const cartSlice = createSlice({
    name: "cart",
    initialState,
    reducers: {
        addToCart(state, action: PayloadAction<Car>) {
            if (!action.payload?.id) return; // 🛑 prevent invalid items
            const existing = state.items.find(
                (item) => item.car.id === action.payload.id
            );

            if (existing) {
                existing.quantity += 1;
            } else {
                state.items.push({ car: action.payload, quantity: 1 });
            }
            // saveCart(state.items);
        },

        removeFromCart(state, action: PayloadAction<string>) {
            state.items = state.items.filter(
                (item) => item.car.id !== action.payload
            );
            // saveCart(state.items);
        },

        clearCart(state) {
            state.items = [];
            // saveCart([]);
        },
    },
});

export const { addToCart, removeFromCart, clearCart } = cartSlice.actions;
export default cartSlice.reducer;

